import { Link, Text } from '@acast/decibel';
import React from 'react';
import Modal from 'shared/components/modal';
import capitalize from 'shared/helpers/capitalize';

const renderDistributionErrorModal = (action, error, showName, integrationType) => {
  if (action === 'add') {
    if (error === 409) {
      return (
        <Modal
          title="Error"
          dialog={
            <Text mb={0}>
              <b>{showName}</b> has already been distributed.
            </Text>
          }
          actions={Modal.Actions.OK}
        />
      );
    }
    return (
      <Modal
        title="Error"
        dialog={
          <Text mb={0}>
            <b>{showName}</b> could not be distributed via {capitalize(integrationType)}. Please try
            it again or contact Acast support at{' '}
            <Link href="mailto:support@acast.com">support@acast.com</Link>.
          </Text>
        }
        actions={Modal.Actions.OK}
      />
    );
  }
  if (action === 'delete') {
    if (error === 404) {
      return (
        <Modal
          title="Error"
          dialog={<Text mb={0}>Show is not accessible or uri is invalid</Text>}
          actions={Modal.Actions.OK}
        />
      );
    }
    return (
      <Modal
        title="Error"
        dialog={
          <Text mb={0}>
            <b>{showName}</b> could not be removed. Please try it again or contact Acast support at{' '}
            <Link href="mailto:support@acast.com">support@acast.com</Link>.
          </Text>
        }
        actions={Modal.Actions.OK}
      />
    );
  }
  if (action === 'get') {
    if (error === 404) {
      return (
        <Modal
          title="Error"
          dialog={<Text mb={0}>Show is not accessible or uri is invalid</Text>}
          actions={Modal.Actions.OK}
        />
      );
    }
    return (
      <Modal
        title="Error"
        dialog={
          <Text mb={0}>
            <b>{showName}</b> could not retreive show distribution status from Spotify. Please try
            it again or contact Acast support at{' '}
            <Link href="mailto:support@acast.com">support@acast.com</Link>.
          </Text>
        }
        actions={Modal.Actions.OK}
      />
    );
  }
  return null;
};

export default renderDistributionErrorModal;
